export { StickyCartBar } from "./StickyCartBar";
export type { StickyCartBarProps } from "./StickyCartBar";
